
import { PEOProvider } from '@/types/peo.types';
import { ProviderCard } from './ProviderCard';

interface ProviderGridProps {
  providers: PEOProvider[];
  onEditProvider: (provider: PEOProvider) => void;
}

export const ProviderGrid = ({ providers, onEditProvider }: ProviderGridProps) => {
  return (
    <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {providers.map((provider) => (
        <ProviderCard 
          key={provider.id}
          provider={provider}
          onClick={onEditProvider}
        />
      ))}
    </div>
  );
};
